/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Plx from 'react-plx';

import { Grid, Typography } from '@mui/material';

import { Namespaces } from '../../../../i18n';
import { createOurMissionSectionStyles } from './OurMissionSection.styles';

const parallaxData = [
  {
    start: '.plxOurMission',
    duration: '40vh',
    properties: [
      {
        startValue: -40,
        endValue: 0,
        unit: 'vh',
        property: 'translateY',
      },
      {
        startValue: 0,
        endValue: 1,
        property: 'opacity',
      },
    ],
  },
];

export const OurMissionSection = memo(() => {
  const classes = createOurMissionSectionStyles();
  const { t } = useTranslation(Namespaces.About);

  return (
    <Grid item md={12} className={classes.root}>
      <div className={classes.container}>
        <Plx className={cx('plxOurMission', classes.plxOurMission)} parallaxData={parallaxData}>
          <Typography variant="h1" classes={{ root: classes.title }}>
            {t('our_mission.title')}
          </Typography>
          <Typography variant="h2" classes={{ root: classes.text }}>
            <Trans>{t('our_mission.text')}</Trans>
          </Typography>
        </Plx>
      </div>
    </Grid>
  );
});
